import { FC } from 'react'
import {
  Box,
  Flex,
  List,
  ListProps,
  Tag,
  TagLabel,
  Text,
} from '@ritualco/jutsu'
import { useContent } from 'lib/content/react'

export type SideNavProps = ListProps
export const SideNav: FC<SideNavProps> = ({ children, ...props }) => {
  return (
    <List
      h="100%"
      overflow="auto"
      bg="grayscale.offWhite"
      boxShadow="inset -1px 0px 0px #E0E0E2, inset 0px -1px 0px #E0E0E2;"
      {...props}
    >
      <Flex direction="column" justify="space-between" h="100%" pt={12}>
        <Box>{children}</Box>
        <SideNavFooter />
      </Flex>
    </List>
  )
}

const SideNavFooter = () => {
  const { formatMessage } = useContent()

  return (
    <Flex p={6} alignItems="center" justifyContent="space-between">
      <Tag size="md" borderRadius="full" variant="solid" bg="black">
        <TagLabel lineHeight="xsmall" fontWeight="medium">
          {formatMessage({ id: 'pmportal.global.tagBeta' })}
        </TagLabel>
      </Tag>
      <Text fontSize="xs" fontWeight="strong" color="grayscale.tertiary">
        {formatMessage(
          { id: 'pmportal.global.version' },
          {
            versionNumber: process.env.REACT_APP_VERSION,
          }
        )}
      </Text>
    </Flex>
  )
}
